


















import { ActivityStatus } from "@/consts";
import Vue, { PropType } from "vue";
const INTERVALS = 2000;

function testSupportTransitionEnd() {
  const el = document.createElement("div");

  const transEndEventNames = {
    WebkitTransition: "webkitTransitionEnd",
    MozTransition: "transitionend",
    transition: "transitionend"
  };

  for (const name in transEndEventNames) {
    if (el.style[name] !== undefined) {
      return true;
    }
  }

  return false; // explicit for ie8 (  ._.)
}

const isSupportTransitionEnd = testSupportTransitionEnd();
export default Vue.extend({
  name: "CheerButton",
  data: () => ({
    btnLoaded: false,
    startAnime: false,
    infiniteLoop: false
  }),
  props: {
    status: {
      type: Number as PropType<ActivityStatus>
    },
    isCollectedAll: {
      type: Boolean,
      default: false
    },
    openRedpack: {
      type: Boolean,
      default: false
    },
    isLogin: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    btnLoaded(val) {
      if (val) {
        if (isSupportTransitionEnd) {
          this.startAnimation();
        } else {
          this.infiniteLoop = true;
        }
      }
    }
  },
  computed: {
    btnClass(): string {
      if (this.status === ActivityStatus.NOT_START) {
        return "static";
      }
      if (this.status === ActivityStatus.COLLECTING) {
        return "collecting";
      }
      if (this.status === ActivityStatus.AWARD) {
        return "static";
      }
      if (this.status === ActivityStatus.RESULT) {
        if (!this.isLogin) {
          return "openning";
        }

        // 没集齐 或者 已经领过了
        if (!this.isCollectedAll || this.openRedpack) {
          return "static";
        }
        return "openning";
      }
      if (this.status === ActivityStatus.END) {
        return "static";
      }
      return "static";
    },
    btnText(): string {
      if (this.status === ActivityStatus.NOT_START) {
        return "活动尚未开始";
      }

      // 登录与否都是展示动效
      if (this.status === ActivityStatus.COLLECTING) {
        return "";
      }

      // 等待开奖
      if (this.status === ActivityStatus.AWARD) {
        if (this.isLogin) {
          if (this.isCollectedAll) {
            return "等待开奖";
          }
          return "活动结束";
        } else {
          return "等待开奖";
        }
      }
      // 瓜分阶段
      if (this.status === ActivityStatus.RESULT) {
        if (this.isLogin) {
          // 未集齐
          if (!this.isCollectedAll) {
            return "活动结束";
          }

          // 已领取过
          if (this.openRedpack) {
            return "奖金已瓜分";
          }

          // 展示瓜分图片
          return "";
        } else {
          // 未登录展示图片
          return "";
        }
      }
      if (this.status === ActivityStatus.END) {
        return "活动已结束";
      }

      return "";
    }
  },
  created() {
    // 预载图
    const image = new Image();

    image.onload = () => {
      this.btnLoaded = true;
    };

    image.onerror = () => {
      this.btnLoaded = true;
    };

    image.src = "//activity.hdslb.com/blackboard/static/20210429/dfa9f6c9df5080266c0de97428ac977b/8IRByJ4dOy.png";
  },
  methods: {
    buttonClicked() {
      this.$emit("button-clicked");
    },
    animeCallback() {
      // add event listener
      this.startAnime = false;
      setTimeout(() => {
        this.startAnime = true;
      }, INTERVALS);
    },
    startAnimation() {
      const $element = this.$refs.cheerBtn as HTMLElement;
      const eventNames = ["webkitAnimationEnd", "mozAnimationEnd", "animationend"];
      eventNames.forEach((event) => {
        $element.addEventListener(event, this.animeCallback);
      });
      this.startAnime = true;
    }
  }
});
